import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/warning-icon.svg'


const _hoisted_1 = { class: "dataset-warning" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Warning",
  class: "dataset-warning-item"
}, null, -1)
const _hoisted_3 = { class: "dataset-warning-message" }
const _hoisted_4 = { class: "dataset-warning-item" }
const _hoisted_5 = { class: "custom-switch" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "slider-round" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.switchValue ? "Filtering suspended" : "You have filtered datasets"), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.switchValue ? "Show with filters on entity details" : "Suspend filtering on entity details"), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("label", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          role: "switch",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.switchValue) = $event)),
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleActiveFilters()))
        }, null, 544), [
          [_vModelCheckbox, _ctx.switchValue]
        ]),
        _hoisted_6
      ])
    ])
  ]))
}